import React, { useState } from "react";
import { CommonButton, CommonModal } from "../Input";
import StepIndicator from "./CreateSingleTransaction/StepIndicator";

// Bulk Sub-components
import Step1CustomerSelection from "./CreateSingleTransaction/Step1CustomerSelection";
import Step1ReceiverList from "./SendBulkTransaction/Step1ReceiverList";
import Step2BulkPaymentInfo from "./SendBulkTransaction/Step2BulkPaymentInfo";
import Step3BulkConfirm from "./SendBulkTransaction/Step3BulkConfirm";
import Step4Denomination from "./SendBulkTransaction/Step4Denomination";
import Step5Success from "./SendBulkTransaction/Step5Success";

const SendBulkTransactionModal = ({ show, onHide }) => {
  const [currentStep, setCurrentStep] = useState(1);
  const [selectedReceivers, setSelectedReceivers] = useState([]);
  const [selectedCustomer, setSelectedCustomer] = useState(null);

  const handleToggleReceiver = (item) => {
    if (selectedReceivers.some((r) => r.id === item.id)) {
      setSelectedReceivers(selectedReceivers.filter((r) => r.id !== item.id));
    } else {
      setSelectedReceivers([...selectedReceivers, item]);
    }
  };

  const handleRemoveReceiver = (id) => {
    setSelectedReceivers(selectedReceivers.filter((r) => r.id !== id));
  };

  const handleUpdateReceiver = (id, updates) => {
    setSelectedReceivers(
      selectedReceivers.map((r) => (r.id === id ? { ...r, ...updates } : r)),
    );
  };

  const handleNext = () => {
    if (currentStep < 6) setCurrentStep(currentStep + 1);
  };

  const handleBack = () => {
    if (currentStep > 1) setCurrentStep(currentStep - 1);
  };

  const handleClose = () => {
    setCurrentStep(1);
    setSelectedReceivers([]);
    setSelectedCustomer(null);
    onHide();
  };

  return (
    <CommonModal
      show={show}
      onHide={handleClose}
      fullscreen={true}
      backdrop="static"
      headerClassName="bg-light-gray-soft"
      bodyClassName="bg-light-gray-soft"
      footerClassName="bg-light-gray-soft pb-4 pt-0"
      title={
        currentStep <= 5 ? (
          <div className="w-100 pe-5">
            <StepIndicator currentStep={currentStep} />
          </div>
        ) : null
      }
      footer={
        currentStep < 5 ? (
          <div className="d-flex justify-content-end gap-3 w-100 px-4 mt-2">
            {currentStep === 2 && (
              <CommonButton
                variant="outline"
                className="px-5 border-light-gray text-black"
                style={{ borderColor: "#ddd" }}
              >
                Add
              </CommonButton>
            )}
            <CommonButton
              variant="secondary"
              className="px-5"
              style={{ borderColor: "#ddd" }}
              onClick={currentStep === 1 ? handleClose : handleBack}
            >
              Back
            </CommonButton>
            <CommonButton
              className="px-5"
              style={{
                backgroundColor:
                  currentStep === 2 && selectedReceivers.length === 0
                    ? "#94A3B8"
                    : "var(--primary)", // Dark Navy
              }}
              disabled={currentStep === 2 && selectedReceivers.length === 0}
              onClick={handleNext}
            >
              {currentStep === 4 ? "Create Transaction" : "Next"}
            </CommonButton>
          </div>
        ) : null
      }
    >
      <div
        className={
          currentStep === 5
            ? "flex-grow-1 d-flex align-items-center justify-content-center"
            : "px-4"
        }
        style={{ minHeight: "550px" }}
      >
        {currentStep === 1 && (
          <Step1CustomerSelection
            selectedCustomer={selectedCustomer}
            onSelectCustomer={setSelectedCustomer}
          />
        )}
        {currentStep === 2 && (
          <Step1ReceiverList
            selectedReceivers={selectedReceivers}
            onToggleReceiver={handleToggleReceiver}
          />
        )}
        {currentStep === 3 && (
          <Step2BulkPaymentInfo
            selectedReceivers={selectedReceivers}
            onRemoveReceiver={handleRemoveReceiver}
            onUpdateReceiver={handleUpdateReceiver}
          />
        )}
        {currentStep === 4 && (
          <Step3BulkConfirm selectedReceivers={selectedReceivers} />
        )}
        {currentStep === 5 && <Step5Success />}
      </div>
    </CommonModal>
  );
};

export default SendBulkTransactionModal;
